import { useCallback, useState } from 'react'

import { updateUserSkinApi } from '@api'
import { useUser } from '@store'

export const useUpdateUserSkins = ({
  onSuccess,
}: {
  onSuccess?: () => void
} = {}) => {
  const [loading, setLoading] = useState(false)
  const { profile } = useUser()

  const handleUpdateUserSkins = useCallback(
    async ({
      avatar,
      spiral,
      star,
      avatarEffect,
    }: {
      avatar?: string
      spiral?: string
      star?: string
      avatarEffect?: string
    }) => {
      setLoading(true)
      const { ok } = await updateUserSkinApi({
        ...(profile?.skinAvatarItemId !== avatar && { avatar }),
        ...(profile?.skinSpiralItemId !== spiral && { spiral }),
        ...(profile?.skinStarsItemId !== star && { star }),
        ...(profile?.skinAvatarEffectId !== avatarEffect && {
          avatarEffect,
        }),
      })

      if (ok) {
        onSuccess?.()
      }

      setLoading(false)
    },
    [onSuccess]
  )

  return {
    loading,
    handleUpdateUserSkins,
  }
}
